import type { StateCreator } from 'zustand';

export interface UISlice {
	showCalendar: boolean;
	skipAnimations: boolean;

	setShowCalendar: (show: boolean) => void;
	setSkipAnimations: (skip: boolean) => void;
}

export const createUISlice: StateCreator<UISlice> = (set) => ({
	showCalendar: true,
	skipAnimations: false,

	setShowCalendar: (show) => set({ showCalendar: show }),
	setSkipAnimations: (skip) => set({ skipAnimations: skip }),
});
